module.exports = __webpack_public_path__ + "img/denmark.1f87a48e.svg";